export const frontends = {
  WEB_POS: 2,
}
